// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PuTNm","controls":"styles_controls__1NVda","charLimit":"styles_charLimit__1diCv","input":"styles_input__iWm3r","send":"styles_send__2QOTG"};